<template>
  <v-container fluid>
    <v-layout column justify-center align-content-start>
      <span class="title text-xs-left mb-2">Dashboard</span>
      <v-divider class="grey"></v-divider>
      <br>
      <v-flex xs12 md8 layout row wrap>
        <v-flex xs12 md4 lg3 xl2 pa-2></v-flex>
        <v-flex xs12 md4 lg3 pa-2>
          <v-card class="secondary" dark>
            <v-card-title>
              <v-flex class="text-xs-left" xs6>
                <span class="subheading ">Recorded Students </span><br/>
                <!-- <span class="body-1 ">new devices</span> -->
              </v-flex>
              <v-flex class="text-xs-center" xs6><span class="headline">{{students}}</span></v-flex>
            </v-card-title>
          </v-card>
        </v-flex>
        <!-- <v-flex xs12 md4 pa-2>
          <v-card dark>
            <v-card-title>
              <v-flex class="text-xs-left" xs6>
                <span class="subheading ">Clients</span>
                <br/><span class="body-1 ">new clients</span>
              </v-flex>
              <v-flex class="text-xs-center" xs6><span class="headline">{{clients}}</span></v-flex>
            </v-card-title>
          </v-card>
        </v-flex> -->
        <v-flex xs12 md4 lg3 pa-2>
          <v-card class="secondary" dark>
            <v-card-title>
              <v-flex class="text-xs-left" xs6>
                <span class="subheading">Admins</span>
                <!-- <br/><span class="body-1 ">new alerts</span> -->
              </v-flex>
              <v-flex class="text-xs-center" xs6><span class="headline">{{admins}}</span></v-flex>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-flex>
      <v-flex xs12 layout row wrap>
        <v-flex xs12 md4 lg3 xl2>
          <v-flex xs12 pa-2>
            <v-card :to="{ name:'activeDevices' }" >
              <v-card-title>
                <v-flex class="text-xs-left" xs6><span class="subheading secondary--text">Courses</span></v-flex>
                <v-flex class="text-xs-center" xs6><span class="headline">{{courses}} </span></v-flex>
              </v-card-title>
            </v-card>
          </v-flex>
          <v-flex xs12 pa-2>
            <v-card :to="{ name:'demoDevices' }" >
              <v-card-title>
                <v-flex class="text-xs-left" xs6><span class="subheading secondary--text">Questions</span></v-flex>
                <v-flex class="text-xs-center" xs6><span class="headline">{{questions}}</span></v-flex>
              </v-card-title>
            </v-card>
          </v-flex>
          <v-flex xs12 pa-2>
            <v-card :to="{ name:'suspendedDevices' }" >
              <v-card-title>
                <v-flex class="text-xs-left" xs6><span class="subheading secondary--text">Student Interactions</span></v-flex>
                <v-flex class="text-xs-center" xs6><span class="headline">{{interactions}}</span></v-flex>
              </v-card-title>
            </v-card>
          </v-flex>
          <!--<v-flex xs12 pa-2>-->
            <!--<v-card :to="{ name:'stolenDevices' }" >-->
              <!--<v-card-title>-->
                <!--<v-flex class="text-xs-left" xs6><span class="subheading secondary&#45;&#45;text">Stolen</span></v-flex>-->
                <!--<v-flex class="text-xs-center" xs6><span class="headline">{{stolen}}</span></v-flex>-->
              <!--</v-card-title>-->
            <!--</v-card>-->
          <!--</v-flex>-->
          <!--<v-flex xs12 pa-2>-->
            <!--<v-card :to="{ name:'damagedDevices' }" >-->
              <!--<v-card-title>-->
                <!--<v-flex class="text-xs-left" xs6><span class="subheading secondary&#45;&#45;text">Damaged</span></v-flex>-->
                <!--<v-flex class="text-xs-center" xs6><span class="headline">{{damaged}}</span></v-flex>-->
              <!--</v-card-title>-->
            <!--</v-card>-->
          <!--</v-flex>-->
          <!--<v-flex xs12 pa-2>-->
            <!--<v-card :to="{ name:'unassignedDevices' }" >-->
              <!--<v-card-title>-->
                <!--<v-flex class="text-xs-left" xs6><span class="subheading secondary&#45;&#45;text"> Unassigned</span></v-flex>-->
                <!--<v-flex class="text-xs-center" xs6><span class="headline">{{unassigned}} </span></v-flex>-->
              <!--</v-card-title>-->
            <!--</v-card>-->
          <!--</v-flex>-->
          <!--<v-flex xs12 pa-2>-->
            <!--&lt;!&ndash;<v-card :to="{ name:'expiredDevices' }" >&ndash;&gt;-->
            <!--<v-card :to="{ name:'toyotaExpiringDevices' }" >-->
              <!--<v-card-title>-->
                <!--<v-flex class="text-xs-left" xs6><span class="subheading secondary&#45;&#45;text">Expiring Soon</span></v-flex>-->
                <!--<v-flex class="text-xs-center" xs6><span class="headline">{{expired}}</span></v-flex>-->
              <!--</v-card-title>-->
            <!--</v-card>-->
          <!--</v-flex>-->
          <!--<v-flex xs12 pa-2>-->
            <!--<v-card :to="{ name:'resuspendedDevices' }" >-->
              <!--<v-card-title>-->
                <!--<v-flex class="text-xs-left" xs6><span class="subheading secondary&#45;&#45;text">Reused Suspended</span></v-flex>-->
                <!--<v-flex class="text-xs-center" xs6><span class="headline">{{reuse}}</span></v-flex>-->
              <!--</v-card-title>-->
            <!--</v-card>-->
          <!--</v-flex>-->
        </v-flex>
        <v-flex xs12 md8 lg9 xl10>
          <v-flex xs12 pa-2 v-for="(alert,index) in alertArray" :key="index">
            <v-card color="accent" dark>
              <v-card-title>
                <v-flex xs3 class="text-xs-left"><span class="headline">{{alert.customer}}</span></v-flex>
                <v-flex xs2 class="text-xs-left"><span class="subheading">{{alert.account_description}}</span></v-flex>
                <v-flex xs3 class="text-xs-left"><span class="subheading">{{alert.imei}}</span></v-flex>
                <v-flex xs2 class="text-xs-left"><span class="subheading">{{alert.dealer_subscription}}</span></v-flex>
                <v-flex xs2 class="text-xs-left"><span class="subheading">{{convertDate(alert.subscription_end)}}</span></v-flex>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DeviceService from "@/services/AuthenticationService";

export default {
  name: "Dashboard",
  components: {},
  data() {
    return {
      alertArray: [],
      // alerts: 0,
      // devices: 0,
      // active: 0,
      // demo: 0,
      // suspended: 0,
      // stolen: 0,
      // damaged: 0,
      // unassigned: 0,
      // expired: 0,
      // reuse: 0,
      // clients: 0,
      // newDevices: 0,
      // newClients: 0,
      // newAlerts: 0
        admins: 0,
        students: 0,
        courses: 0,
        interactions: 0,
        questions: 0,
    };
  },
  mounted(){
    this.getAll();
  },
  computed: {
    dayLength: function(){
      var millisecond = 1;
      var second = millisecond * 1000;
      var minute = second * 60;
      var hour = minute * 60;
      var day = hour * 24;
      return day;
    }
  },
  methods: {
    async getAll() {
      try {
        // eslint-disable-next-line
        var color = "info";
        console.log("Dashboard get all");
        const response = await DeviceService.getDashboard();
        console.log(response);
        // const allResponse = await DeviceService.getAll();
        // const assignedResponse = await DeviceService.getAssigned();
        // const expiredResponse = await DeviceService.getExpired();
        // const reusedResponse = await DeviceService.getReusedSuspended();

        // if (allResponse.data.code > 200 || assignedResponse.data.code > 200 || expiredResponse.data.code > 200 || reusedResponse.data.code > 200) {
        //   color = "warning";
        // } else if (allResponse.data.result == 2000 && assignedResponse.data.result == 2000 && expiredResponse.data.result == 2000 && reusedResponse.data.result == 2000) {
        //   this.$store.dispatch("setDevices", allResponse.data.data);
        //   this.$store.dispatch("setAssignedDevices", assignedResponse.data.data);
        //   this.$store.dispatch("setExpiredDevices", expiredResponse.data.data);
        //   this.$store.dispatch("setReusedSuspendedDevices", reusedResponse.data.data);
        //
        //   this.devices = (this.$store.state.devices.devices.records).length
        //   this.active = this.$store.getters.activeCount;
        //   this.demo = this.$store.getters.demoCount;
        //   this.suspended = this.$store.getters.suspendedCount;
        //   this.stolen = this.$store.getters.stolenCount;
        //   this.damaged =  this.$store.getters.damagedCount;
        //   this.expired =  this.$store.getters.expiredCount;
        //   this.reused =  this.$store.getters.reusedCount;
        //   this.unassigned =  this.$store.getters.allUnassignedCount;
        //   this.checkSubscription();
        //
        // }

        if (response.data.code > 200) {
          color = "warning";
        } else if (response.data.result == 2000) {
          // console.log('devices:', response.data.data);
          // this.devices = ((response.data.data.unassigned || 0) + (response.data.data.active || 0) + (response.data.data.demo || 0)
          //                 + (response.data.data.suspended || 0) + (response.data.data.expired || 0) + (response.data.data.damaged || 0)
          //                 + (response.data.data.reuse || 0) );
          // this.active = response.data.data.active;
          // this.demo = response.data.data.demo;
          // this.suspended = response.data.data.suspended;
          // this.stolen = response.data.data.stolen;
          // this.damaged =  response.data.data.damaged;
          // this.expired =  response.data.data.expired;
          // this.reuse =  response.data.data.reuse;
          // this.unassigned =  response.data.data.unassigned;
          // this.checkSubscription();
          console.log('All information:', response.data.data);

          this.admins = response.data.data.admins;
          this.students = response.data.data.students;
          this.interactions = response.data.data.interactions;
          this.questions = response.data.data.questions;
          this.courses = response.data.data.courses;
        }

        this.$store.dispatch("setSnackbar", {show: true, text: "Success", color: color, x: "right", timeout: 3000});
      } catch (err) {
        console.log(err);
        this.$store.dispatch("setSnackbar", {show: true, text: "Error occured", color: "error", x: "right", timeout: 3000});
      }
    },
    convertDate: function (date){
      return date.split('T')[0];
    },
    checkSubscription: function(){
      var devices = JSON.parse(JSON.stringify(this.$store.state.devices.assignedDevices.records));

      for (var i=0; i<devices.length; i++) {

        if(devices[i].subscription_end && devices[i].dealer_subscription){
          var endDate = new Date(devices[i].subscription_end);
          var today = new Date();
          if((endDate.getTime() - today.getTime()) < this.dayLength*30){
            console.log(endDate.getTime() - today.getTime());
            this.alertArray.push(devices[i]);
          }
        }
      }
    }
  }
};
</script>

<style scoped>

</style>
